import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  Message,
  TextArea,
  InputField,
  ActionButton,
} from "../../component/Component";
import { FOLDERS } from "../../../doseeData/utils/Utils";
import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useBannerContext } from "../../../../context/banner/BannerContext";
import { getOneBanner } from "../../../../middlewares/sysNavigation/SysNavigation";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import {
  FiImage,
  FiType,
  FiEye,
  FiEyeOff,
  FiInfo,
  FiTag,
  FiUpload,
} from "react-icons/fi";

const Edit = () => {
  const { updateBannerState, updateBanner } = useBannerContext();
  const banner = getOneBanner();
  const banner_id = banner?.banner_id;
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [type, setType] = useState(banner?.type);
  const [message, setErrorMessage] = useState("");
  const [title, setTitle] = useState(banner?.title);
  const [thumbnail, setThumbnail] = useState(banner?.thumbnail);
  const [bannerStatus, setEventStatus] = useState(banner?.status);
  const [description, setDescription] = useState(banner?.description);
  const [thumbnailId, setThumbnailId] = useState(banner?.image_cdn_id);
  const bannerRoutes = "/banner";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError, st, msg) => {
    setError(isError);
    setStatus(st);
    setErrorMessage(msg);
  };

  const updateOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      status: bannerStatus,
      type: type,
    };

    const response = await updateBanner(banner_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateBannerState({ banner_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  const statusChip =
    bannerStatus === 1 ? (
      <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700 text-[11px] font-semibold">
        <FiEye className="h-3.5 w-3.5" />
        Visible
      </span>
    ) : (
      <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700 text-[11px] font-semibold">
        <FiEyeOff className="h-3.5 w-3.5" />
        Invisible
      </span>
    );

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4">
      <GoBack props={{ route: bannerRoutes }} />

      <form onSubmit={updateOneEventHandler} className="mx-auto mt-2 max-w-6xl">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-2 px-5 pt-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <FiImage className="h-5 w-5" />
              </span>
              <div>
                <Title props={{ title: "Edit Banner" }} />
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700 text-[11px] font-semibold">
                    <FiType className="h-3.5 w-3.5" />
                    {type || "—"}
                  </span>
                  {statusChip}
                </div>
              </div>
            </div>
            <div className="text-[11px] text-gray-600">
              <span className="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-[2px] font-semibold">
                <FiInfo className="h-3.5 w-3.5" />
                Changes take effect immediately after saving
              </span>
            </div>
          </div>

          <div className="px-5 pb-5">
            <div className="mt-4">
              <Message
                props={{
                  error,
                  success,
                  message,
                  loading,
                  status,
                  onClick: () => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  },
                }}
              />
            </div>

            <div className="mt-4 grid grid-cols-1 gap-6 lg:grid-cols-3">
              <div className="lg:col-span-1">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
                  <div className="mb-3 flex items-center justify-between">
                    <div className="text-sm font-semibold text-gray-900">Banner Image</div>
                    <span className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                      <FiUpload className="h-3 w-3" />
                      1600×600 jpg/png
                    </span>
                  </div>
                  <ImageKitUpload
                    thumbnail={thumbnail}
                    thumbnailId={thumbnailId}
                    setThumbnail={setThumbnail}
                    setThumbnailId={setThumbnailId}
                    folder={FOLDERS.BANNER}
                  />
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm space-y-5">
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <InputField
                      props={{
                        id: "title",
                        title: "Title",
                        type: "text",
                        value: title ? title : "",
                        onChange: (e) => {
                          setTitle(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <Select
                      props={{
                        id: "type",
                        title: "Page",
                        option: [
                          "home",
                          "about",
                          "tour",
                          "market",
                          "contact",
                          "attraction",
                          "best",
                          "cities",
                          "countries",
                          "events",
                          "hotels",
                          "parties",
                          "safaris",
                          "timeframe events",
                        ],
                        preselect: [{ name: type }],
                        onChange: (e) => {
                          setType(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <Select
                      props={{
                        id: "banner_status",
                        title: "Status",
                        option: ["visible", "invisible"],
                        preselect:
                          bannerStatus !== null
                            ? [
                              {
                                name: bannerStatus === 1 ? "visible" : "invisible",
                              },
                            ]
                            : null,
                        onChange: (e) => {
                          if (e.target.selectedIndex === 0) setEventStatus(1);
                          else setEventStatus(0);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                  </div>

                  <div className="grid grid-cols-1 gap-4">
                    <TextArea
                      props={{
                        id: "description",
                        title: "Description",
                        type: "text",
                        value: description ? description : "",
                        onChange: (e) => {
                          setDescription(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <div className="flex items-center gap-2 text-[11px] text-gray-600">
                      <FiTag className="h-3.5 w-3.5" />
                      Keep descriptions concise and informative.
                    </div>
                  </div>

                  <div className="pt-2">
                    <ActionButton
                      props={{
                        title: ` Save Changes`,
                        error,
                        success,
                        message,
                        loading,
                        status,
                        onClick: () => {
                          setError(false);
                          setSuccess(false);
                          setErrorMessage("");
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
